import { previewSections } from '../constants'
import { imageGroups } from '../hooks/useThemeImages/constants'

export const imageGroupsNames = {
  [imageGroups.general]: 'General',
  [imageGroups.backgrounds]: 'Imágenes de fondo',
  [imageGroups.returnsPortal]: 'Portal devoluciones / Panel de cliente',
  [imageGroups.tracking]: 'Página de seguimiento',
}

export const previewableGroups = {
  [imageGroups.returnsPortal]: previewSections.returnsPortal,
  [imageGroups.tracking]: previewSections.trackingPage,
}

export const hiddenGroups = [imageGroups.emails]
